<template>
  <el-table
    :data="rows"
    size="small"
    style="width:100%;"
    :row-class-name="rowClassName"
  >
    <el-table-column
      label="Termék"
      prop="name"
    />
    <el-table-column
      label="Csomagolás"
      prop="pack_type_name"
      width="130"
    />
    <el-table-column
      label="Szavatosság"
      width="120"
    >
      <template slot-scope="scope">
        {{ scope.row.expiration_date || '—' }}
      </template>
    </el-table-column>
    <el-table-column
      label="Beszállító"
      width="160"
    >
      <template slot-scope="scope">
        {{ scope.row.supplier_name || '—' }}
      </template>
    </el-table-column>
    <el-table-column
      label="Listán"
      width="90"
      align="right"
    >
      <template slot-scope="scope">
        {{ scope.row.required }} {{ unit(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column
      label="Kirakva"
      width="90"
      align="right"
    >
      <template slot-scope="scope">
        {{ scope.row.placed }} {{ unit(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column
      label="Állapot"
      width="190"
    >
      <template slot-scope="scope">
        <el-tag
          v-if="scope.row.ok"
          size="small"
          type="success"
        >
          Kész
        </el-tag>
        <el-tag
          v-else-if="scope.row.incomplete"
          size="small"
          type="danger"
        >
          Hiányzik: {{ scope.row.missing }} {{ unit(scope.row) }}
        </el-tag>
        <el-tag
          v-else
          size="small"
          type="warning"
        >
          Hátralévő: {{ scope.row.remaining }} {{ unit(scope.row) }}
        </el-tag>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    sourceItems: {
      type: Array,
      default() {
        return [];
      },
    },
    coverage: {
      type: Array,
      default() {
        return [];
      },
    },
    // Per-product completeness (missing quantities) from GET desadvs/{id}.
    completeness: {
      type: Array,
      default() {
        return [];
      },
    },
    // Show missing quantities as red "Hiányzik" rows (finalized DESADV);
    // while still open, unfinished rows stay neutral "Hátralévő".
    highlightIncomplete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rows() {
      return (this.sourceItems || []).map((item) => {
        const cov = (this.coverage || []).find(c => c.key === item.key) || {};
        const compl = (this.completeness || []).find(c => c.key === item.key);
        return {
          key: item.key,
          name: item.name,
          pack_type_name: item.pack_type_name,
          expiration_date: item.expiration_date,
          supplier_name: item.supplier_name,
          count_per_pack: item.count_per_pack,
          required: cov.required != null ? cov.required : item.count,
          placed: cov.placed || 0,
          remaining: cov.remaining != null ? cov.remaining : item.count,
          ok: !!cov.ok,
          incomplete: !!(this.highlightIncomplete && compl && !compl.ok),
          missing: compl ? compl.missing : 0,
        };
      });
    },
  },
  methods: {
    unit(row) {
      return row.count_per_pack === 1 ? 'db' : (row.pack_type_name || 'cs');
    },
    rowClassName({ row }) {
      return row.incomplete ? 'coverage-incomplete-row' : '';
    },
  },
};
</script>
<style>
  .coverage-incomplete-row td {
    color: #F56C6C;
  }
</style>
